<template>
    <header
        :class="[$style.header, isSearchOpened && $style.search_opened]"
        data-interface-section="desktop-header"
    >
        <Link
            :to="{ name: ROUTE_NAMES.MAIN }"
            data-interface-target="navigation-link"
            :class="$style.icon_wrapper"
            hoverAnimation="rainbow"
        >
            <Icon
                name="playgama_logo"
                :class="$style.icon_logo"
            />
        </Link>
        <div :class="$style.flexible_block">
            <TasksWidget :class="$style.tasks_widget_override" />
            <Search
                @open="isSearchOpened = true"
                @close="isSearchOpened = false"
            />
            <template v-if="isUserInfoLoaded && isMounted">
                <NoAdButton />
                <template v-if="user && isAuthorized">
                    <UserWidget
                        :user="user"
                        :isProfilePage="isUserProfilePage"
                        :userBalance="userBalance"
                    />
                    <LogoutButton
                        v-if="isUserProfilePage"
                        @logout="logout"
                    />
                </template>
                <Button
                    v-else
                    size="l"
                    color="salad"
                    interfaceTarget="open-sign-in-modal"
                    :class="$style.sign_in_button_override"
                    @click="signin"
                >
                    {{ $tr('mobileHeader.login') }}
                </Button>
            </template>
            <HeaderTiles :class="$style.header_tiles_override" />
        </div>
    </header>
</template>
<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { computed, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import Button from '@/components_new/Button.vue'
import Icon from '@/components_new/Icon/Icon.vue'
import Link from '@/components_new/Link.vue'
import TasksWidget from '@/components_new/TaskItems/TasksWidget.vue'
import { ROUTE_NAMES } from '@/router/constants'
import { useLayoutStore } from '@/store/layout-store'
import { useUserStore } from '@/store/user-store/user-store'
import { useIsMounted } from '@/utils/vue-hooks/use-is-mounted'

import Search from '../Search/Search.vue'
import HeaderTiles from './components/HeaderTiles.vue'
import LogoutButton from './components/LogoutButton.vue'
import NoAdButton from './components/NoAdButton.vue'
import UserWidget from './components/UserWidget.vue'

const layoutStore = useLayoutStore()
const userStore = useUserStore()
const router = useRouter()
const route = useRoute()
const isMounted = useIsMounted()
const isSearchOpened = ref(false)
const isUserProfilePage = computed(() => route.name === ROUTE_NAMES.PROFILE)
const { isAuthorized, isUserInfoLoaded, user, userBalance } = storeToRefs(userStore)

async function logout() {
    await userStore.logout()
    router.replace({ name: ROUTE_NAMES.MAIN })
}

function signin() {
    layoutStore.setSignInModalOpened(true)
}
</script>
<style module>
.header {
    display: flex;
    align-items: center;
    height: 100%;
    gap: 4px;
}

.flexible_block {
    display: flex;
    flex-grow: 1;
    align-items: center;
    gap: 4px;
}

.header_tiles_override {
    margin-left: auto;
}

.icon_wrapper {
    border-radius: 62px;
    background-color: var(--purple-400);
    padding: 0 20px;
    display: flex;
    align-items: center;
    height: 56px;
}

.icon_wrapper:hover,
.icon_wrapper:focus {
    filter: brightness(1.08);
}

.icon_logo {
    height: 34px;
    width: 160px;
}

.sign_in_button_override {
    height: 56px;
}

.search_opened .tasks_widget_override,
.search_opened .header_tiles_override {
    display: none;
}

@media (--desktop-large-plus) {
    .search_opened .header_tiles_override {
        display: flex;
    }
}
</style>
